(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sw-premium"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.swp-menu a').forEach((link)=>{link.addEventListener('click',()=>{link.closest('details').open=false;});});

  } catch(e) { console.error(e); }
})();
})();
